import { Component, OnInit, HostListener } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import { User } from '../classes/User';

@Component({
  selector: 'app-referral',
  templateUrl: './referral.component.html',
  styleUrls: ['./referral.component.css']
})
export class ReferralComponent implements OnInit {

  user: User;
  loading = true;
  showDropdown = false;

  datauri = "";

  constructor(private authServ: AuthService) { }

  ngOnInit(): void {
    this.datauri = "data:image/png;base64,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";
    	this.authServ.getHostDetail()
			.subscribe((res: any) => {
				this.user = new User(res);
				this.loading = false;
			})
  }

	@HostListener('document:click', ['$event'])
	onClickOutside(event: any) {
		const target = event.target as HTMLElement;
		const dropdownContainer = target.closest('.dropdown-container');

		if (!dropdownContainer && this.showDropdown) {
			this.showDropdown = false;
		}
	}

  toggleDropdown() {
		this.showDropdown = !this.showDropdown;
	}

	downloadReferralCard() {
		this.showDropdown = false;
	  let doc = new jsPDF({
		    orientation: "landscape",
		    unit: "mm",
		    format: "a4"
		});

    const pageWidth = 297;
    const pageHeight = 210;

    const cardWidth = 85.6;
    const cardHeight = 54;

    const marginX =10;
    const marginY = 10;
    const spacingX = 10;
    const spacingY = 10;

    const cardsPerRow = Math.floor((pageWidth - 2 * marginX + spacingX) / (cardWidth + spacingX));
    const cardsPerColumn = Math.floor((pageHeight - 2 * marginY + spacingY) / (cardHeight + spacingY));
    const totalPerPage = cardsPerRow * cardsPerColumn;

    const totalCards = 9;

    for (let i = 0; i < totalCards; i++) {
      const positionInPage = i % totalPerPage;

      if (positionInPage === 0 && i !== 0) {
        doc.addPage();
      }

      const col = positionInPage % cardsPerRow;
      const row = Math.floor(positionInPage / cardsPerRow);

      const x = marginX + col * (cardWidth + spacingX);
      const y = marginY + row * (cardHeight + spacingY);

      this.drawReferralCard(doc, x, y, cardWidth, cardHeight, this.datauri);
    }

    const pdfBlob = doc.output("blob");
    this.exportPdf(pdfBlob, `${this.user.name}_referral_cards`);

	}

  drawReferralCard(doc: jsPDF, x: number, y: number, w: number, h: number, datauri: string) {
    // border
    doc.setDrawColor("#f1f0f5");
    doc.rect(x, y, w, h);

    // header
    doc.setFontSize(24);
    doc.setTextColor("#d42a2a");
    doc.text("BOOK KING TRIVIA", x + w / 2, y + 10, { align: "center" });

    // body text
    doc.setFontSize(13);
    doc.setTextColor("black");
    doc.text("• Weekly Trivia Nights", x + 5, y + 18);
    doc.text("• Private Events", x + 5, y + 24);
    doc.text("• Themed Games", x + 5, y + 30);
    doc.text("• And More!", x + 5, y + 36);
    // referred by
    doc.setTextColor("#d42a2a");
    doc.setFontSize(10);
    doc.text("Referred by:", x + 5, y + 43);

    // footer banner
    doc.setFillColor("#d42a2a");
    doc.rect(x, y + h - 10, w, 10, "F");
    doc.setTextColor("white");
    doc.setFontSize(14);
    doc.text(this.user.name, x + w / 2, y + h - 3.5, { align: "center" });

    // qr code image
    doc.addImage(datauri, "PNG", x + w - 33.5 , y + 11, 32, 32);
  }

  exportPdf(data: Blob, fileName: string) {
    const url = window.URL.createObjectURL(data);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  downloadReferralCardImage() {
    const element = document.getElementById('referralCard');
    if (!element) return;

    html2canvas(element, { scale: 3 }).then(canvas => {
      const imgData = canvas.toDataURL('image/png');
      const link = document.createElement('a');
      link.href = imgData;
      link.download = 'referral-card.png';
      link.click();
    });
  }

}
